import axios from "axios";
import { fetchApi, BASE_URL } from "../Utils/helper";
import { API_ENDPOINTS } from "../Constants/endpoints";
import { getAccessToken } from "../Utils/localStore";

// Get All Products
export const getProductsService = async (
  page = 1,
  perPage = 12,
  search = "",
  category = ""
) => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('page', page);
    queryParams.append('per_page', perPage);
    if (search?.trim()) {
      queryParams.append('search', search.trim());
    }
    if (category) {
      queryParams.append('category', category);
    }
    
    const url = `${API_ENDPOINTS.GET_PRODUCTS}?${queryParams.toString()}`;
    
    const response = await fetchApi({
      method: "GET",
      endPoint: url,
    });
    
    return response;
  } catch (error) {
    console.error("getProductsService error", error);
    throw error;
  }
};

// Get All Categories
export const getCategoriesService = async () => {
  try {
    const response = await fetchApi({
      method: "GET",
      endPoint: API_ENDPOINTS.GET_CATEGORIES,
    });
    
    return response;
  } catch (error) {
    console.error("getCategoriesService error", error);
    throw error;
  }
};

// Store Product
export const storeProductService = async (productData) => {
  try {
    const response = await fetchApi({
      method: "POST",
      endPoint: API_ENDPOINTS.ADD_PRODUCT,
      data: productData,
      formData: true,
    });
    
    return response;
  } catch (error) {
    console.error("storeProductService error", error);
    throw error;
  }
};

// Delete Product
export const deleteProductService = async (productId) => {
  try {
    const response = await fetchApi({
      method: "DELETE",
      endPoint: API_ENDPOINTS.DELETE_PRODUCT(productId),
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("deleteProductService error", error);
    throw error;
  }
};

// Update Product Service
export const updateProductService = async (productId, productData) => {
  try {
    const response = await fetchApi({
      method: "POST",
      endPoint: API_ENDPOINTS.UPDATE_PRODUCT(productId),
      data: productData,
      formData: true,
    });
    
    return response;
  } catch (error) {
    console.error("updateProductService error", error);
    throw error;
  }
};

// Get All Orders
export const getOrdersService = async (page, perPage, search = "") => {
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (perPage) queryParams.append("per_page", perPage);
    if (search?.trim()) {
      queryParams.append("search", search.trim());
    }

    const response = await fetchApi({
      method: "GET",
      endPoint: `${API_ENDPOINTS.GET_ORDERS}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("getOrdersService error", error);
    throw error;
  }
};

// Get Email Templates
export const getEmailTemplatesService = async (page, perPage) => {
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (perPage) queryParams.append("per_page", perPage);

    const response = await fetchApi({
      method: "GET",
      endPoint: `${API_ENDPOINTS.GET_EMAIL_TEMPLATES}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
      token: true,
    });

    return response;
  } catch (error) {
    console.error("getEmailTemplatesService error", error);
    throw error;
  }
};

// Get Free Tapes
export const getFreeTapesService = async (page, perPage, search = "") => {
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (perPage) queryParams.append("per_page", perPage);
    if (search?.trim()) {
      queryParams.append("search", search.trim());
    }

    const response = await fetchApi({
      method: "GET",
      endPoint: `${API_ENDPOINTS.GET_FREE_TAPES}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
      token: true,
    });

    return response;
  } catch (error) {
    console.error("getFreeTapesService error", error);
    throw error;
  }
};

// Update Free Tape Status
export const updateFreeTapeStatusService = async (tapeId, status) => {
  try {
    const response = await fetchApi({
      method: "POST",
      endPoint: API_ENDPOINTS.UPDATE_FREE_TAPE_STATUS(tapeId),
      data: { status },
      token: true,
    });

    return response;
  } catch (error) {
    console.error("updateFreeTapeStatusService error", error);
    throw error;
  }
};

// Update Email Template
export const updateEmailTemplateService = async (key, templateData) => {
  try {
    const response = await fetchApi({
      method: "POST",
      endPoint: API_ENDPOINTS.UPDATE_EMAIL_TEMPLATE(key),
      data: templateData,
      token: true,
    });

    return response;
  } catch (error) {
    console.error("updateEmailTemplateService error", error);
    throw error;
  }
};

// Export Orders CSV
export const exportOrdersService = async (status = "") => {
  try {
    const queryParams = new URLSearchParams();
    if (status && status !== "all") {
      queryParams.append("status", status);
    }

    const accessToken = getAccessToken();
    const url = `${BASE_URL}/api/${API_ENDPOINTS.EXPORT_ORDERS}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
    const config = {
      method: "GET",
      url,
      responseType: "blob",
      headers: accessToken
        ? {
            Authorization: `Bearer ${accessToken}`,
          }
        : {},
    };

    console.log("EXPORT ORDERS API REQUEST:", config);
    const response = await axios(config);
    console.log("EXPORT ORDERS API SUCCESS:", {
      status: response.status,
      filename: response.headers["content-disposition"],
      size: response.data?.size,
      type: response.data?.type,
    });

    return {
      blob: response.data,
      filename: response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "orders.csv",
    };
  } catch (error) {
    console.error("EXPORT ORDERS API ERROR:", error.response?.data || error.message);
    throw error;
  }
};

// Delete Order
export const deleteOrderService = async (orderId) => {
  try {
    const response = await fetchApi({
      method: "DELETE",
      endPoint: `${API_ENDPOINTS.DELETE_ORDER}/${orderId}`,
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("deleteOrderService error", error);
    throw error;
  }
};

// Update Order Status Service
export const updateOrderStatusService = async (orderId, status) => {
  try {
    const response = await fetchApi({
      method: "POST",
      endPoint: API_ENDPOINTS.UPDATE_ORDER_STATUS,
      data: { order_id: orderId, status: status },
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("updateOrderStatusService error", error);
    throw error;
  }
};

// Get Product Variants
export const getProductVariantsService = async (page, perPage, productId) => {
  try {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page);
    if (perPage) queryParams.append("per_page", perPage);

    const response = await fetchApi({
      method: "GET",
      endPoint: `${API_ENDPOINTS.GET_PRODUCT_VARIANTS(productId)}${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("getProductVariantsService error", error);
    throw error;
  }
};

// Update Variant Quantity
export const updateVariantQuantityService = async (variantId, quantity) => {
  try {
    const response = await fetchApi({
      method: "POST",
      endPoint: API_ENDPOINTS.UPDATE_VARIANT_QUANTITY(variantId),
      data: { stock_quantity: quantity },
      token: true,
    });
    
    return response;
  } catch (error) {
    console.error("updateVariantQuantityService error", error);
    throw error;
  }
};
